import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const navLinks = [
    { labelKey: "nav.home", path: "/" },
    { labelKey: "nav.about", path: "/about" },
    { labelKey: "nav.services", path: "/services" },
    { labelKey: "nav.news", path: "/news" },
  ];

  return (
    <footer className="bg-navy-dark text-white">
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <img
              src="https://storage.readdy-site.link/project_files/d916de51-3f57-462f-a700-620facc3e09c/96d60ca8-e1eb-45a0-b27f-a662d0ca5b1e_EU-LOGO-W1.png?v=85a6b8a22d2db99c2b056706e2aee0e2"
              alt="EU Next Grants"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs uppercase tracking-widest text-gold mb-4 font-medium">Navigation</p>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/70 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {t(link.labelKey)}
                  </Link>
                </li>
              ))}

            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs uppercase tracking-widest text-gold mb-4 font-medium">Contact</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-gold text-base" />
                </span>
                <span>Str. Maria Cebotari 37,<br />Chișinău, Moldova</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-gold text-base" />
                </span>
                <a href="mailto:info@eunextgrants.md" className="hover:text-white transition-colors">
                  info@eunextgrants.md
                </a>
              </li>

            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} EU Next Grants. {t("footer.rights")}
          </p>
          <p className="text-xs text-white/40">
            Consulting &amp; Project Support for Moldovan NGOs
          </p>
        </div>
      </div>
    </footer>
  );
}
